export function selectUnavailableRulesets(state) {
  const { byId } = state.products.propertyPriorities;

  return Object.keys(byId).map((id) => byId[id].ruleset.name);
}
